"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("@mui/material/utils");
var SvgBatteryTwotone50 = (0, utils_1.createSvgIcon)(react_1.default.createElement(react_1.default.Fragment, {}, react_1.default.createElement("path", { d: "M24 0v24H0V0Z", fill: "none" }), react_1.default.createElement("path", { d: "M20 10V8.33A1.34 1.34 0 0 0 18.67 7H12v10h6.67A1.34 1.34 0 0 0 20 15.67V14h2v-4Z", fillOpacity: 0.3 }), react_1.default.createElement("path", { d: "M12 7H3.34A1.34 1.34 0 0 0 2 8.33v7.33A1.34 1.34 0 0 0 3.33 17H12Z" })), 'SvgBatteryTwotone50');
exports.default = SvgBatteryTwotone50;
